"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));
/* eslint-disable */


var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 37.9997C29.4934 37.9997 38 29.4932 38 18.9998C38 8.50634 29.4934 -0.000244141 19 -0.000244141C8.50659 -0.000244141 0 8.50634 0 18.9998C0 29.4932 8.50659 37.9997 19 37.9997Z",
    fill: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0416 15.0415C34.0416 25.5349 25.535 34.0415 15.0416 34.0415C10.8045 34.0415 6.89142 32.6545 3.73145 30.3099C7.19346 34.9759 12.7436 37.9998 18.9999 37.9998C29.4933 37.9998 37.9999 29.4932 37.9999 18.9998C37.9999 12.7434 34.976 7.19334 30.3101 3.73132C32.6547 6.8913 34.0416 10.8044 34.0416 15.0415Z",
    fill: "#FFD13E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.4896 20.9789C13.6595 20.9789 16.2292 18.4092 16.2292 15.2393C16.2292 12.0695 13.6595 9.49976 10.4896 9.49976C7.3197 9.49976 4.75 12.0695 4.75 15.2393C4.75 18.4092 7.3197 20.9789 10.4896 20.9789Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.5103 20.9789C30.6802 20.9789 33.2499 18.4092 33.2499 15.2393C33.2499 12.0695 30.6802 9.49976 27.5103 9.49976C24.3405 9.49976 21.7708 12.0695 21.7708 15.2393C21.7708 18.4092 24.3405 20.9789 27.5103 20.9789Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.4792 18.2081C12.463 18.2081 13.2605 17.4106 13.2605 16.4269C13.2605 15.4431 12.463 14.6456 11.4792 14.6456C10.4955 14.6456 9.698 15.4431 9.698 16.4269C9.698 17.4106 10.4955 18.2081 11.4792 18.2081Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.5 18.2081C29.4838 18.2081 30.2812 17.4106 30.2812 16.4269C30.2812 15.4431 29.4838 14.6456 28.5 14.6456C27.5162 14.6456 26.7188 15.4431 26.7188 16.4269C26.7188 17.4106 27.5162 18.2081 28.5 18.2081Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7291 26.1248H12.2708V28.4998H25.7291V26.1248Z",
    fill: "black"
  }));
};

exports.default = _default;